import { getConfig } from 'web-app/shared/white-labeling-constants';
import { currentTheme } from 'web-app/styleguide/themes';
import { signinAppConfigs, resolveThemeValue } from 'web-app/styleguide/themes/signin-app-configs';
import { signinAppLogos } from './logos';
/**
 * Resolves a logo for a given whitelabel and variant.
 * Uses static imports (via logos.ts) so webpack copies the image into dist, generates a url and serves the image.
 *
 * @param whitelabel - The whitelabel identifier, or null for default Famly
 * @param variant - Which logo variant to resolve
 * @returns Bundled image URL, or null if no logo is configured for this whitelabel
 */
const resolveLogo = (whitelabel, variant) => {
    var _a, _b;
    return (_b = (_a = signinAppLogos[whitelabel !== null && whitelabel !== void 0 ? whitelabel : 'famly']) === null || _a === void 0 ? void 0 : _a[variant]) !== null && _b !== void 0 ? _b : null;
};
/**
 * Builds the WhiteLabelConfiguration for a given whitelabel.
 * Color and style overrides are driven by signin-app-configs.ts (co-located with the themes),
 * so adding a new whitelabel only requires an entry there and static logo imports in logos.ts.
 *
 * @param whitelabel - The whitelabel identifier, or null for default Famly
 * @returns The complete WhiteLabelConfiguration
 */
export const buildConfiguration = (whitelabel) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const theme = currentTheme();
    // null means the default Famly experience, which has its own entry in signinAppConfigs
    const overrides = (_a = signinAppConfigs[whitelabel !== null && whitelabel !== void 0 ? whitelabel : 'famly']) !== null && _a !== void 0 ? _a : {};
    const productName = whitelabel
        ? ((_c = (_b = getConfig(whitelabel, 'app_name')) !== null && _b !== void 0 ? _b : getConfig(whitelabel, 'title')) !== null && _c !== void 0 ? _c : 'Famly')
        : 'Famly';
    const mobileAppUrl = whitelabel
        ? ((_d = getConfig(whitelabel, 'app_url_scheme')) !== null && _d !== void 0 ? _d : 'com.famly.famlyapp')
        : 'com.famly.famlyapp';
    return {
        ProductName: productName,
        MobileAppUrl: mobileAppUrl,
        LoginPagesFontColor: (_e = overrides.loginPagesFontColor) !== null && _e !== void 0 ? _e : 'n0',
        PinButtonColor: (_f = overrides.pinButtonColor) !== null && _f !== void 0 ? _f : 'n0',
        PinShadowColor: (_g = resolveThemeValue(overrides.pinShadowColor, theme)) !== null && _g !== void 0 ? _g : theme.invertedText,
        PinPillColor: (_h = resolveThemeValue(overrides.pinPillColor, theme)) !== null && _h !== void 0 ? _h : theme.mf.colorPalette.p300,
        PinPillEmptyColor: (_j = resolveThemeValue(overrides.pinPillEmptyColor, theme)) !== null && _j !== void 0 ? _j : theme.invertedText,
        PrimaryColor: theme.mf.colorPalette.n400,
        PrimaryBackgroundColor: (_k = resolveThemeValue(overrides.primaryBackgroundColor, theme)) !== null && _k !== void 0 ? _k : theme.chromeColor,
        SecondaryBackgroundColor: (_l = resolveThemeValue(overrides.secondaryBackgroundColor, theme)) !== null && _l !== void 0 ? _l : theme.chromeColor,
        CircleAndDotColor: (_m = resolveThemeValue(overrides.circleAndDotColor, theme)) !== null && _m !== void 0 ? _m : theme.primary,
        PinLogo: (_o = resolveLogo(whitelabel, 'pinPage')) !== null && _o !== void 0 ? _o : resolveLogo(whitelabel, 'pin'),
        PinLogoHeight: resolveLogo(whitelabel, 'pinPage')
            ? { base: '28px', tabletPortrait: '40px' }
            : { base: '40px', tabletPortrait: '64px' },
        LoginLogo: resolveLogo(whitelabel, 'pin'),
        LogoForWhiteBg: resolveLogo(whitelabel, 'whiteBg'),
        LogoMarkForWhiteBg: (_p = resolveLogo(whitelabel, 'whiteBgMark')) !== null && _p !== void 0 ? _p : resolveLogo(whitelabel, 'whiteBg'),
        LogoMarkHeight: resolveLogo(whitelabel, 'whiteBgMark') ? '32px' : '44px',
        WithSiteImage: true,
        p500: resolveThemeValue(overrides.p500, theme),
        p400: overrides.p400,
        p300: overrides.p300,
        p200: overrides.p200,
    };
};
